export default __webpack_public_path__ + "static/media/forteSaoFrancisco-large.88e4976f.jpg";